import { black, blue, textGray } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const SectionsTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const SectionsTitle = styled.h1`
  font-size: ${fonts.xl}px;
  color: ${black};
`;

export const TitleLine = styled.hr`
  background-color: ${textGray};
  height: 2px;
  border: 0;
  width: 100%;
  margin: ${spacing.md}px 0 ${spacing.xl}px 0;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;

  > * {
    width: calc(50% - 48px);
  }

  ${media.tablet} {
    flex-direction: column;

    > * {
      margin: ${spacing.xl}px 0;
      width: 100%;
    }
  }
`;

export const Info = styled.div``;

export const Heading = styled.h1`
  color: ${black};
  font-size: ${fonts.md}px;
  margin: ${spacing.lg}px 0;
  font-weight: 500;
`;

export const Text = styled.p`
  line-height: 22px;
  margin-bottom: ${spacing.xl}px;

  > a {
    color: ${blue};
  }
`;
